const CompanyBusinessArea = {

    // FIELDS
    "company": 'Company',
    "name": "Name",
    "description": 'Description',
    "address": "Address",
    "code": 'Code',
    "postal_code": "Postal Code",
    "email": "Email",
    "phone": "Phone Number",
    "mobile_no": "Mobile Number",
    "state": "State",
    "city": "City",
    "country": "Country",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "bussiness_area": "Business Area",

    // ERROR
    "error_company": "Select Company",
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_address": "Enter Address",
    "error_code": "Enter Code",
    "error_postal_code": "Enter Postal Code",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone Number",
    "error_mobile_no": "Enter Mobile Number",
    "error_country": "Select Country",
    "error_state": "Select State",
    "error_city": "Select City",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_city": "CITY",
    "table_mobile_no": "MOBILE",
    "table_status": "STATUS",
}

export default CompanyBusinessArea;